// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { TableTotalsVisibility } from './TableTotalsVisibility';
export class DefaultLotTableItem extends BaseItem {
    constructor(selectiveLot, id) {
        super(null);
        this.selectiveLot = selectiveLot;
        this.itemId = id;
    }
    ColumnCount() {
        return DefaultLotTableItem.columnsParams.length;
    }
    GetColumnParams(column) {
        const par = DefaultLotTableItem.columnsParams[column];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    getColumnData(column) {
        const val = this.getColumnValue(column);
        return new ColumnData(val, val ? val.toString() : '');
    }
    getColumnValue(column) {
        const selectiveLot = this.selectiveLot;
        switch (column) {
            case 0:
                return selectiveLot.Selected;
            case 1:
                return selectiveLot.Lots;
            default:
                return null;
        }
    }
}
DefaultLotTableItem.columnsParams = [
    new ColumnParams('TypesManagerScreen.QuickTable.Column.Enable', 80, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('TypesManagerScreen.QuickTable.Column.Default lots', 110, QTAlignment.Left, TableTotalsVisibility.None, true, false)
];
